import React from 'react';
import './ContactSection.css';
import { FaClock, FaPhone, FaEnvelope, FaComments } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ContactSection = (props) => {
  // Determine background style
  const backgroundStyle = props.backgroundImage
    ? {
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : props.backgroundColor
    ? {
        backgroundColor: props.backgroundColor,
      }
    : {};

  return (
    <section
      className="contact-section"
      id="contact-us"
      style={backgroundStyle}
    >
      <div className="contact-wrapper">
        <div className="contact-left">
          <div className="contact-headings">
            <h2 className="black1-title">NEW PROJECT IN MIND?</h2>
            <h2 className="blue-title">LET'S TALK</h2>
          </div>

          <div className="contact-response">
            <FaClock /> <span>Response in less than 1 hour</span>
          </div>

          <div className="contact-details">
            <p><FaEnvelope /> info@latticelabs.com</p>
            <p><FaComments /> Chat</p>
          </div>

          <Link to="/contact" className="mobile-contact-btn">
            Contact Form
          </Link>
        </div>

        <div className="contact-right">
          <div className="form-card">
            <div className="form-title">
              <h3 className="black1-title">Explain your project and</h3>
              <h3 className="blue1-title">book a meeting today.</h3>
            </div>

            <form>
              <div className="form-row">
                <input type="text" placeholder="Name*" required />
                <input type="text" placeholder="Company*" required />
              </div>

              <div className="form-row">
                <input type="email" placeholder="Email*" required />
                <input type="text" placeholder="Phone" />
              </div>

              <select required>
                <option value="">I am looking for*</option>
                <option value="web">Web Development</option>
                <option value="mobile">Mobile App</option>
                <option value="uiux">UI/UX Design</option>
              </select>

              <textarea placeholder="Message*" rows="4" required></textarea>

              <select>
                <option value="">How did you hear about us?</option>
                <option value="google">Google</option>
                <option value="referral">Referral</option>
                <option value="social">Social Media</option>
              </select>

              <div className="file-upload">
                <label>
                  File upload (optional)
                  <input type="file" />
                </label>
              </div>

              <div className="checkbox">
                <input type="checkbox" required />
                <label>I allow Lattice Labs to store and process my personal data*</label>
              </div>

              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;